import { ISignupPage } from '@/api/signup/interface';
import { RouteConfig } from 'vue-router';
import { clientResolution } from '../util/client';

const routerPathSegmentPrefix = clientResolution.routerPathSegmentPrefix;

export enum SystemPagesEnum {
  Strategy = 'strategy',
  Progress = 'progress',
  ValidisConsent = 'validisConsent',
  ValidisAreYouSure = 'validisAreYouSure',
  Success = 'success',
  ReConsentSuccess = 'reconsentsuccess',
  Error = 'error',
  ReConsentError = 'reconsenterror',
  ValidisError = 'validisError',
  Deny = 'deny',
  Declined = 'declined',
  Cancelled = 'cancelled',
  Scenario = 'scenario',
  Reconsent = 'reconsent',
  ApplyPlus = 'applyplus' 
}
const invertedSystem = Object.keys(SystemPagesEnum).reduce((c: any, n: any) => {
  c[(SystemPagesEnum as any)[n]] = n;
  return c;
}, {});

export const systemPages = Object.keys(invertedSystem);
export const isSystemPage = (name: string) => !!invertedSystem[name];

export enum StaticPagesEnum {
  Welcome = 'welcome',
  Connect = 'connect',
  Mastercard = 'mastercard',
  MastercardRedirect = 'mastercardredirect',
  Consent = 'consent',
  // Yodlee = 'yodlee',
  Register = 'register',
  Validis = 'validis',
  // Progress = 'progress',
  UkAddress = 'ukaddress',
  CustomerReference = 'customerreference',
  Collections = 'collections',
  CollectionsEmployment = 'collectionsemployment',
  CollectionsBau = 'collectionsbau',
  CollectionsBauPriority = 'collectionsbaupriority',
  CollectionsBus = 'collectionsbus',
  CollectionsBusEmployment = 'collectionsbusemployment',
  CollectionsBusRFD = 'collectionsbusrfd',
  IEMethod = 'iemethod',
  HouseholdComposition = 'householdcomposition',
  FinancialCircumstances = 'financialcircumstances',
  Income = 'income',
  MonthlyExpenditure = 'monthlyexpenditure',
  Reconsent = 'reconsent',
  CreditCheckConsent='creditcheckconsent',
  ApplyPlus = 'applyplus'
}

const invertedStatic = Object.keys(StaticPagesEnum).reduce((c: any, n: any) => {
  c[(StaticPagesEnum as any)[n]] = n;
  return c;
}, {});

export const staticPages = Object.keys(invertedStatic);
export const isStaticPage = (name: string) => !!invertedStatic[name];

export const getStaticConfig = (name: string) => {  
  const n = invertedStatic[name];
  return (staticConfig as any)[name] as Partial<RouteConfig> & Partial<ISignupPage>;
};

export const staticConfig: {
  [id in StaticPagesEnum]: Partial<RouteConfig> & Partial<ISignupPage>
} = {
  [StaticPagesEnum.Welcome]: {
    name: StaticPagesEnum.Welcome,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Welcome,
    // title: 'Welcome',
    type: StaticPagesEnum.Welcome,
    component: () => import(/* webpackChunkName: "welcome-page" */ '@/views/Welcome.vue'),
  },
  [StaticPagesEnum.ApplyPlus]: {
    name: StaticPagesEnum.ApplyPlus,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.ApplyPlus,
    // title: 'Detail',
    type: StaticPagesEnum.ApplyPlus,
    component: () => import(/* webpackChunkName: "applyplus-page" */ '@/views/ApplyPlus.vue'),
  },
  [StaticPagesEnum.Register]: {
    name: StaticPagesEnum.Register,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Register,
    // title: 'Welcome',
    type: StaticPagesEnum.Register,
    component: () => import(/* webpackChunkName: "register-page" */ '@/views/Register.vue'),
  },
  [StaticPagesEnum.Connect]: {
    name: StaticPagesEnum.Connect,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Connect,
    // title: 'Connect',
    type: StaticPagesEnum.Connect,
    component: () => import(/* webpackChunkName: "connect-page" */ '@/views/Connect.vue'),
  },
  [StaticPagesEnum.Mastercard]: {
    name: StaticPagesEnum.Mastercard,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Mastercard,
    // title: 'Mastercard',
    type: StaticPagesEnum.Mastercard,
    component: () => import(/* webpackChunkName: "mastercard-page" */ '@/views/Mastercard.vue'),
  },
  [StaticPagesEnum.MastercardRedirect]: {
    name: StaticPagesEnum.MastercardRedirect,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.MastercardRedirect,
    // title: 'Mastercard Redirect',
    type: StaticPagesEnum.MastercardRedirect,
    component: () => import(/* webpackChunkName: "mastercardredirect-page" */ '@/views/MastercardRedirect.vue'),
  },
  [StaticPagesEnum.Consent]: {
    name: StaticPagesEnum.Consent,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Consent,
    // title: 'Consent',
    type: StaticPagesEnum.Consent,
    component: () => import(/* webpackChunkName: "consent-page" */ '@/views/Consent.vue'),
  },
  [StaticPagesEnum.UkAddress]: {
    name: StaticPagesEnum.UkAddress,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.UkAddress,
    // title: 'Address',
    type: StaticPagesEnum.UkAddress,
    component: () => import(/* webpackChunkName: "address-page" */ '@/views/UkAddress.vue')
  },
  [StaticPagesEnum.CustomerReference]: {
    name: StaticPagesEnum.CustomerReference,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CustomerReference,
    type: StaticPagesEnum.CustomerReference,
    component: () => import(/* webpackChunkName: "customer-reference" */ '@/views/CustomerReference.vue')
  },
  [StaticPagesEnum.Validis]: {
    name: StaticPagesEnum.Validis,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Validis,
    type: StaticPagesEnum.Validis,
    component: () => import(/* webpackChunkName: "validisdata-page" */ '@/views/ValidisData.vue'),
  },
  [StaticPagesEnum.Collections]: {
    name: StaticPagesEnum.Collections,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Collections,
    type: StaticPagesEnum.Collections,
    component: () => import(/* webpackChunkName: "collections-page" */ '@/views/Collections.vue')
  },
  [StaticPagesEnum.CollectionsEmployment]: {
    name: StaticPagesEnum.CollectionsEmployment,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CollectionsEmployment,
    type: StaticPagesEnum.CollectionsEmployment,
    component: () => import(/* webpackChunkName: "Collections-employment-page" */ '@/views/CollectionsEmployment.vue')
  },
  [StaticPagesEnum.CollectionsBau]: {
    name: StaticPagesEnum.CollectionsBau,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CollectionsBau,
    type: StaticPagesEnum.CollectionsBau,
    component: () => import(/* webpackChunkName: "Collections-bau-page" */ '@/views/CollectionsBau.vue')
  },
  [StaticPagesEnum.CollectionsBauPriority]: {
    name: StaticPagesEnum.CollectionsBauPriority,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CollectionsBauPriority,
    type: StaticPagesEnum.CollectionsBauPriority,
    component: () => import(/* webpackChunkName: "Collections-bau-page" */ '@/views/CollectionsBauPriority.vue')
  },
  [StaticPagesEnum.CollectionsBus]: {
    name: StaticPagesEnum.CollectionsBus,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CollectionsBus,
    type: StaticPagesEnum.CollectionsBus,
    component: () => import(/* webpackChunkName: "Collections-bus-page" */ '@/views/CollectionsBus.vue')
  },
  [StaticPagesEnum.CollectionsBusEmployment]: {
    name: StaticPagesEnum.CollectionsBusEmployment,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CollectionsBusEmployment,
    type: StaticPagesEnum.CollectionsBusEmployment,
    component: () => import(/* webpackChunkName: "Collections-bus-employment-page" */ '@/views/CollectionsBusEmployment.vue')
  },
  [StaticPagesEnum.CollectionsBusRFD]: {
    name: StaticPagesEnum.CollectionsBusRFD,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CollectionsBusRFD,
    type: StaticPagesEnum.CollectionsBusRFD,
    component: () => import(/* webpackChunkName: "Collections-bus-RFD-page" */ '@/views/CollectionsBusRFD.vue')
  },
  [StaticPagesEnum.IEMethod]: {
    name: StaticPagesEnum.IEMethod,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.IEMethod,
    type: StaticPagesEnum.IEMethod,
    component: () => import(/* webpackChunkName: "IE-method-page" */ '@/views/IEMethod.vue')
  },
  [StaticPagesEnum.HouseholdComposition]: {
    name: StaticPagesEnum.HouseholdComposition,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.HouseholdComposition,
    type: StaticPagesEnum.HouseholdComposition,
    component: () => import(/* webpackChunkName: "Household-composition-page" */ '@/views/HouseholdComposition.vue')
  },
  [StaticPagesEnum.FinancialCircumstances]: {
    name: StaticPagesEnum.FinancialCircumstances,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.FinancialCircumstances,
    type: StaticPagesEnum.FinancialCircumstances,
    component: () => import(/* webpackChunkName: "Financial-circumstances-page" */ '@/views/FinancialCircumstances.vue')
  },
  [StaticPagesEnum.Income]: {
    name: StaticPagesEnum.Income,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Income,
    type: StaticPagesEnum.Income,
    component: () => import(/* webpackChunkName: "Income-page" */ '@/views/Income.vue')
  },
  [StaticPagesEnum.MonthlyExpenditure]: {
    name: StaticPagesEnum.MonthlyExpenditure,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.MonthlyExpenditure,
    type: StaticPagesEnum.MonthlyExpenditure,
    component: () => import(/* webpackChunkName: "Monthly-expenditure-page" */ '@/views/MonthlyExpenditure.vue')
  },
  [StaticPagesEnum.Reconsent]: {
    name: StaticPagesEnum.Reconsent,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.Reconsent,
    // title: 'Reconsent',
    type: StaticPagesEnum.Reconsent,
    component: () => import(/* webpackChunkName: "reconsent-page" */ '@/views/Reconsent.vue'),
  },
  [StaticPagesEnum.CreditCheckConsent]: {
    name: StaticPagesEnum.CreditCheckConsent,
    path: routerPathSegmentPrefix + '/' + StaticPagesEnum.CreditCheckConsent,
    type: StaticPagesEnum.CreditCheckConsent,
    component: () => import(/* webpackChunkName: "consent-page" */ '@/views/CreditCheckConsent.vue'),
  }
  };
